module.exports = __webpack_public_path__ + "media/main_video.2ad6b85a.webm";